import React, { Fragment } from 'react'
import { Route, Switch } from 'react-router-dom'

import ScrollToTop from './components/ScrollToTop'
import { ToastContainer, Slide } from 'react-toastify'

import './App.css'
import '../node_modules/@fortawesome/fontawesome-free/css/all.css'
import 'bootstrap/dist/css/bootstrap.min.css'

import { withAuthContainer } from './hocs/withAuthContianer'

import IntercomMenu from './components/IntercomMenu'
import Footer from './components/Footer'

import { LoginPage } from './modules/Login'
import Logout from './modules/Logout'
import Checkout from './modules/Checkout'
import ThankyouPage from './modules/ThankYou'
import MealDetail from './modules/MealDetail'

import Menu from './modules/Menu'

import 'react-toastify/dist/ReactToastify.css'

const App = ({ authed }) => (
  <div className="app-routes-container">
    <ToastContainer
      transition={Slide}
      className="toast-container"
      toastClassName="toast-content"
      progressClassName="toast-progress-bar"
    />
    <IntercomMenu.IntercomMenuDesktop />
    <ScrollToTop>
      <Switch>
        {/* Routes inside Fragment will have Footer */}
        <Fragment>
          {/* TODO: move header here too. */}
          <Route path="/login" component={LoginPage} />
          <Route
            path="/logout"
            render={props => <Logout {...props} authed={authed} />}
          />

          <Route path="/" exact component={Menu} />
          <Route path="/checkout" component={Checkout} />
          <Route path="/thankyou" component={ThankyouPage} />

          <Route path="/products/:productId" component={MealDetail} />
          <Footer />
        </Fragment>
      </Switch>
    </ScrollToTop>
  </div>
)

export default withAuthContainer(App)



// WEBPACK FOOTER //
// ./src/App.js